export default {
      id: "icon--info-usage",
      viewBox: "0 0 31 31",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--info-usage",
      toString: function () {
        return this.url;
      }
    }